var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "lb-table-mini",
      class: { "is-goods-selector": _vm.isGoodsSelector },
    },
    [
      _c(
        "el-table",
        _vm._g(
          _vm._b(
            {
              ref: "elTable",
              attrs: {
                data: _vm.data,
                "span-method": this.merge ? this.mergeMethod : this.spanMethod,
              },
            },
            "el-table",
            _vm.$attrs,
            false
          ),
          _vm.$listeners
        ),
        _vm._l(_vm.column, function (item, index) {
          return _c(
            "lb-column",
            _vm._b(
              { key: index, attrs: { column: item } },
              "lb-column",
              _vm.$attrs,
              false
            )
          )
        }),
        1
      ),
      _c("div", { staticClass: "mini-pagination" }, [
        _c("div", { staticClass: "table-info" }, [
          _vm._v(
            " " +
              _vm._s(_vm.statisticText) +
              ": " +
              _vm._s(_vm.orderStatistics) +
              " "
          ),
        ]),
        _c(
          "div",
          { staticClass: "mini-pagination-con" },
          [
            _c(
              "div",
              {
                staticClass: "btn-refresh primary",
                on: {
                  click: function ($event) {
                    return _vm.$emit("refresh")
                  },
                },
              },
              [_vm._v("刷新"), _c("i", { staticClass: "el-icon-refresh" })]
            ),
            _vm.pagination
              ? _c(
                  "el-pagination",
                  _vm._g(
                    _vm._b(
                      {
                        staticClass: "lb-table-pagination",
                        style: {
                          "margin-top": _vm.paginationTop,
                          "text-align": _vm.paginationAlign,
                        },
                        on: { "current-change": _vm.paginationCurrentChange },
                      },
                      "el-pagination",
                      _vm.$attrs,
                      false
                    ),
                    _vm.$listeners
                  )
                )
              : _vm._e(),
          ],
          1
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }